module.exports = (_, opts) => ({
  plugins: [
    ['@babel/plugin-transform-flow-strip-types'],
    ['@babel/plugin-proposal-class-properties', { loose: false }],
    ['@babel/plugin-proposal-decorators', { legacy: true }],
    ['@babel/plugin-proposal-do-expressions'],
    ['@babel/plugin-proposal-export-default-from'],
    ['@babel/plugin-proposal-export-namespace-from'],
    ['@babel/plugin-proposal-function-bind'],
    ['@babel/plugin-proposal-function-sent'],
    ['@babel/plugin-proposal-json-strings'],
    ['@babel/plugin-proposal-logical-assignment-operators'],
    ['@babel/plugin-proposal-nullish-coalescing-operator', { loose: false }],
    ['@babel/plugin-proposal-numeric-separator'],
    ['@babel/plugin-proposal-object-rest-spread'],
    ['@babel/plugin-proposal-optional-catch-binding'],
    ['@babel/plugin-proposal-optional-chaining', { loose: false }],
    ['@babel/plugin-proposal-pipeline-operator', { proposal: 'minimal' }],
    ['@babel/plugin-proposal-throw-expressions'],
    ['@babel/plugin-proposal-unicode-property-regex'],
    ['@babel/plugin-syntax-dynamic-import'],
    ['@babel/plugin-syntax-import-meta'],
    ['babel-plugin-preval'],
  ],
  presets: [
    ['@babel/preset-env', { loose: true, shippedProposals: true, ...opts }],
  ],
});
